import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  ClockIconComponent,
  ArrowLeftIconComponent,
  EmptyCircleIconComponent,
  FinalStepIconComponent,
  FilledCircleIconComponent,
} from '@kuiper/icons';
import {
  StepsDiagramAssignee,
  StepsDiagramStep,
} from '../../../models/steps-diagram.model';
import { Option } from '../../../models/option.model';
import { TooltipDirective } from '../../../../../ui-components/lib/tooltip/tooltip.directive';
import { TruncatePipe } from '../../../../../ui-components/pipes/truncate/truncate.pipe';

@Component({
  selector: 'lib-tree-step-card',
  imports: [
    TranslocoPipe,
    TooltipDirective,
    TruncatePipe,
    ClockIconComponent,
    ArrowLeftIconComponent,
    EmptyCircleIconComponent,
    FinalStepIconComponent,
    FilledCircleIconComponent,
  ],
  templateUrl: './tree-step-card.component.html',
  styleUrl: './tree-step-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TreeStepCardComponent implements OnInit {
  step = input.required<StepsDiagramStep>();
  positionName = input.required<string>();
  applyMinHeight = input<boolean>(false);
  stepIndex = input<number>();
  positionsLength = input<number>(0);
  hasEmptyCircle = input<boolean>(false);
  isFirstPosition = input<boolean>(false);
  assigneeData = signal<any[]>([]);

  ngOnInit(): void {
    this.assigneeData.set(this.getAssigneeData(this.step().assignees));
  }

  getAssigneeData(assignees: StepsDiagramAssignee[]): any[] {
    return assignees.map(assignee => {
      return {
        ...assignee.data,
        assignable_type: assignee.assignable_type ?? 'variable',
        option:
          assignee.option &&
          typeof assignee.option === 'object' &&
          'label' in assignee.option
            ? this.setOptionLabel(assignee)
            : assignee.option,
      };
    }) as any[];
  }

  setOptionLabel(assignee: StepsDiagramAssignee) {
    return assignee.assignable_type === 'department'
      ? (assignee.option as Option).label
      : '';
  }
}
